import { render } from "./TrafficVersusDoorReport.vue?vue&type=template&id=12f6a5d8"
import script from "./TrafficVersusDoorReport.vue?vue&type=script&lang=js"
export * from "./TrafficVersusDoorReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__